import { isSupportedCountry, parsePhoneNumberFromString } from 'libphonenumber-js';

export function isValidContactPhone(value: string, country: string): boolean {
  const phone = value.trim();
  if (phone === '') return true;
  const region = isSupportedCountry(country) ? country : undefined;
  return parsePhoneNumberFromString(phone, region)?.isValid() ?? false;
}
